import {TableActionDropdownMenu} from "../../../components/Table/TableActionDropdownMenu";
import {DropdownItem} from "../../../components";
import React from "react";
import useProfileEditableState from "../../../hooks/useProfileEditableState";
import {useAnalyticsTrackers} from "../../../utils/useAnalyticsTrackers";

type AccountActionMenuProps = {
    onRemoveInvestmentProgram: () => void,
    onRefreshInvestmentProgramHoldings: () => void
    investmentProgramName: string,
    isActiveClient?: boolean,
    hasInvestmentProgram?: boolean,
}

const AccountActionMenu = ({onRemoveInvestmentProgram, onRefreshInvestmentProgramHoldings, investmentProgramName, isActiveClient, hasInvestmentProgram }
                               : AccountActionMenuProps) => {
    const ipName = investmentProgramName?.length > 20 ? investmentProgramName?.substring(0, 20) + "..." : investmentProgramName;
    const {isProfileWithProposalsOrArchived} = useProfileEditableState();
    const { page } = useAnalyticsTrackers("enableAssetsGoogleAnalytics");

    return (
        <TableActionDropdownMenu ariaLabel={`Accounts Menu`}>
            <DropdownItem
                itemText="Refresh Holdings"
                value="Refresh Holdings"
                onClick={() => {
                    page("Click_AssetSummary_InvestmentProgram_RefreshHoldings");
                    onRefreshInvestmentProgramHoldings()
                }}
                disabled={!isActiveClient || isProfileWithProposalsOrArchived}
            />
            {hasInvestmentProgram &&
                <DropdownItem
                    itemText={`Remove ${ipName}`}
                    value="Remove Investment Program"
                    onClick={() => {
                        page("Click_AssetSummary_InvestmentProgram_Remove");
                        onRemoveInvestmentProgram()
                    }}
                    disabled={!isActiveClient || isProfileWithProposalsOrArchived}
                />}
        </TableActionDropdownMenu>
    )
};

export default AccountActionMenu;